import {
  createStyles,
  makeStyles,
  TextField,
  Theme,
  Typography
} from '@material-ui/core';
import React from 'react';
import EditCommonLabel from './EditCommonLabel';
import EditCommonInfo from './EditCommonInfo';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    elementPreview: { marginTop: theme.spacing(4), width: '70%' }
  })
);

interface EditTextProps {
  onUpdateElementLabel: (e: any) => void;
  onUpdateElementInfo: (e: any) => void;
  label: string;
  info: string;
}

export const EditText = ({
  onUpdateElementLabel,
  onUpdateElementInfo,
  label,
  info
}: EditTextProps) => {
  const classes = useStyles();
  return (
    <>
      <EditCommonLabel onChange={onUpdateElementLabel} value={label} />
      <Typography style={{ marginTop: 14 }}>
        <EditCommonInfo onChange={onUpdateElementInfo} value={info} />
      </Typography>
      <TextField
        className={classes.elementPreview}
        disabled
        placeholder="Tekstikenttä"
      />
    </>
  );
};
export default EditText;
